import { render, staticRenderFns } from "./datatables_icare_join.vue?vue&type=template&id=df5e3d98&"
import script from "./datatables_icare_join.vue?vue&type=script&lang=js&"
export * from "./datatables_icare_join.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports